import { useParams, useSearchParams } from 'react-router-dom';
import { FilesTab } from './patient/consultation/FilesTab';
import { NotesTab } from './patient/consultation/NotesTab';
import { FormsTab } from './patient/consultation/FormsTab';
import { InvoicesTab } from './patient/consultation/InvoicesTab';

export function PatientConsultationPage() {
  const { id: patientId } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'files';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      {activeTab === 'files' && <FilesTab patientId={patientId ?? ''} />}
      {activeTab === 'notes' && <NotesTab patientId={patientId ?? ''} />}
      {activeTab === 'forms' && <FormsTab patientId={patientId ?? ''} />}
      {activeTab === 'invoices' && (
        <InvoicesTab
          patientId={patientId ?? ''}
          initialInvoiceId={searchParams.get('invoiceId') ?? undefined}
        />
      )}
    </div>
  );
}
